import type { VpnGatewayProvisioning, VpnGatewayRecord } from '@fleet-cert-console/shared';

/** Provisioned column: the Thing's status (lower-cased) with the confirm time when known. */
export function provisionedLabel(p: VpnGatewayProvisioning | undefined): string {
  if (!p) return '—';
  const status = p.status.toLowerCase();
  return p.confirmedAt ? `${status} · ${p.confirmedAt}` : status;
}

/** Customer / project column from the Thing attributes. */
export function customerProjectLabel(p: VpnGatewayProvisioning | undefined): string {
  if (!p || (!p.customer && !p.project)) return '—';
  return `${p.customer ?? '—'} / ${p.project ?? '—'}`;
}

/** Text filter for the gateways table, covering the visible columns and the provisioning block. */
export function gatewayMatches(g: VpnGatewayRecord, text: string): boolean {
  const needle = text.trim().toLowerCase();
  if (!needle) return true;
  const hay = [
    g.gatewayId,
    g.hostname,
    g.groupId,
    g.vpnStatus ?? 'not enrolled',
    g.vpnIp,
    g.provisioning?.status,
    g.provisioning?.customer,
    g.provisioning?.project,
  ]
    .filter((v): v is string => Boolean(v))
    .join(' ')
    .toLowerCase();
  return hay.includes(needle);
}
